import { render, staticRenderFns } from "./TabSlideForm.vue?vue&type=template&id=67fa5fc6&scoped=true"
import script from "./TabSlideForm.vue?vue&type=script&lang=js"
export * from "./TabSlideForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fa5fc6",
  null
  
)

export default component.exports